import { SimpleGrid } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import ResumoContainer from "./ResumoContainer";
import moment from "moment";

function Resumo({ selectedDate }: { selectedDate: moment.Moment }) {
  return (
    <SimpleGrid
      mt="16px"
      columns={{ sm: 1, md: 1, lg: 1, xl:2 }}
      gap="32px"
      mb="48px"
    >
      <ResumoContainer
        dataInicio={moment().set("h", 0).set("minutes", 1).format("YYYY-MM-DD")}
        dataFim={moment().set("h", 23).set("minutes", 59).format("YYYY-MM-DD")}
        title="Resumo de hoje"
        color={colors.primary}
      />
      <ResumoContainer
        dataInicio={selectedDate
          .set("h", 0)
          .set("minutes", 1)
          .startOf("month")
          .format("YYYY-MM-DD")}
        dataFim={selectedDate
          .endOf("month")
          .set("h", 23)
          .set("minutes", 59)
          .format("YYYY-MM-DD")}
        title={`Resumo em ${selectedDate.format("MMMM[ ]YYYY")}`}
        color={colors.primaryLight}
      />
    </SimpleGrid>
  );
}

export default Resumo;
